{
  "title": "Frost Fingers",
  "source": "Icewind Dale - Rime of the Frostmaiden",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self (15-foot cone)",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "Freezing cold blasts from your fingertips in a 15-foot cone. Each creature in that area must make a Constitution saving throw, taking 2d8 cold damage on a failed save, or half as much damage on a successful one.",
    "The cold freezes nonmagical liquids in the area that aren't being worn or carried.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the damage increases by 1d8 for each slot level above 1st."
  ],
  "spellLists": ["eldritch-knight", "wizard"]
}
